import type { ProductGalleryQueryQuery as Query } from '@generated/graphql'
import { Suspense, lazy } from 'react'
import ProductGridSkeleton from 'src/components/skeletons/ProductGridSkeleton'

import styles from '../../product/ProductGrid/product-grid.module.scss'

const GalleryPage = lazy(() => import('./ProductGalleryPage'))

const GalleryPageSkeleton = <ProductGridSkeleton loading />

interface GalleryPageProps {
  data: Query | undefined
  title: string
  itemsPerPage: number
  sessionPage: number
}

const GalleryPages = ({
  data,
  title,
  itemsPerPage,
  sessionPage,
}: GalleryPageProps) => {
  return (
    <>
      {data && sessionPage ? (
        <Suspense fallback={GalleryPageSkeleton}>
          <ul
            data-fs-product-grid
            className={`${styles.fsProductGrid} plp__product-listing-results`}
          >
            {Array.from({ length: sessionPage }, (_, index) => (
              <GalleryPage
                key={`gallery-page-${index}`}
                showSponsoredProducts={false}
                page={index}
                title={title}
                itemsPerPage={itemsPerPage}
              />
            ))}
          </ul>
        </Suspense>
      ) : (
        GalleryPageSkeleton
      )}
    </>
  )
}

export default GalleryPages
